import react, { createContext, useState } from "react";

export const CheckboxCandidateContext = createContext();

export const CheckboxCandidateProvider = ({ children }) => {
    const [CheckboxCandidate, setCheckboxCandidate] = useState({});
    // console.log(CheckboxCandidate, "checkbox candidate===")
    return (
      <CheckboxCandidateContext.Provider value={ { CheckboxCandidate ,  setCheckboxCandidate } }>
        {children}
      </CheckboxCandidateContext.Provider>
    );
  };